<template>
  <div class="certification_details">
    <div class="tit">
      <span>
        <router-link
          to="/personal_center/enterprise/admission_to_the_park/admission_to_the_park_certificaiton_table_list"
          class="back"
        >
          <i class="el-icon-arrow-left"></i>
        </router-link>园区入驻详情
      </span>
    </div>
    <div class="body_content">
      <h2>创始人信息</h2>
      <el-row v-if="detail">
        <el-col :span="5">
          <div class="detail_l">创始人照片：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r">
            <img :src="detail.founder_coverPath" style="width: 82px;height: 82px;" alt />
          </div>
        </el-col>
        <el-col :span="5">
          <div class="detail_l">创始人姓名：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r">{{detail.founder_name}}&nbsp;</div>
        </el-col>
        <el-col :span="5">
          <div class="detail_l">性别：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r">{{detail.founder_sex_name}}&nbsp;</div>
        </el-col>
        <el-col :span="5">
          <div class="detail_l">创始人身份证件号码：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r">{{detail.founder_identification}}&nbsp;</div>
        </el-col>
        <el-col :span="5">
          <div class="detail_l">出生年月：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r">{{detail.founder_birthday}}&nbsp;</div>
        </el-col>
        <el-col :span="5">
          <div class="detail_l">创始人身份证明材料：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r">
            <a
              target="_blank"
              v-if="detail.founder_identification_filePath && detail.founder_identification_filePath.length"
              :href="detail.founder_identification_filePath"
              :download="detail.founder_identification_filePath"
            >查看附件</a>&nbsp;
          </div>
        </el-col>
        <el-col :span="5">
          <div class="detail_l">手机号码：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r">{{detail.founder_phone}}&nbsp;</div>
        </el-col>
        <el-col :span="5">
          <div class="detail_l">电子邮箱：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r">{{detail.founder_email}}&nbsp;</div>
        </el-col>
        <el-col :span="5">
          <div class="detail_l">其他联系方式：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r">{{detail.founder_other}}&nbsp;</div>
        </el-col>
        <el-col :span="5">
          <div class="detail_l">最高学历：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r">{{detail.founder_education_name}}&nbsp;</div>
        </el-col>
        <el-col :span="5">
          <div class="detail_l">专业名称：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r">{{detail.founder_major}}&nbsp;</div>
        </el-col>
        <el-col :span="5">
          <div class="detail_l">联系地址：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r">{{detail.founder_address}}&nbsp;</div>
        </el-col>
        <el-col :span="5">
          <div class="detail_l">邮政编码：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r">{{detail.founder_postcode}}&nbsp;</div>
        </el-col>
        <el-col :span="5">
          <div class="detail_l">目前状况：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r">{{detail.founder_status_name}}&nbsp;</div>
        </el-col>
        <el-col :span="5">
          <div class="detail_l">创业经历：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r">{{detail.founder_business==='true'?"有":"无"}}&nbsp;</div>
        </el-col>
        <el-col :span="5">
          <div class="detail_l">工作经历：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r">{{detail.founder_work}}&nbsp;</div>
        </el-col>
      </el-row>
      <h2>项目信息</h2>
      <el-row>
        <el-col :span="5">
          <div class="detail_l">期望入驻园区：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r">{{detail.incubator_name}}&nbsp;</div>
        </el-col>
        <el-col :span="5">
          <div class="detail_l">项目/公司名称：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r">{{detail.name}}&nbsp;</div>
        </el-col>
        <el-col :span="5" v-if="detail.project_business_filePath">
          <div class="detail_l">营业执照扫描件：</div>
        </el-col>
        <el-col :span="19" v-if="detail.project_business_filePath">
          <div class="detail_r">
            <a
              target="_blank"
              v-if="detail.project_business_filePath.length"
              :href="detail.project_business_filePath"
              download="营业执照扫描件"
            >查看附件</a>&nbsp;
          </div>
        </el-col>
        <el-col :span="5">
          <div class="detail_l">营业执照注册时间：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r">{{detail.operation_date}}&nbsp;</div>
        </el-col>
        <el-col :span="5">
          <div class="detail_l">营业执照注册资本：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r">{{detail.register_money}}&nbsp;</div>
        </el-col>
        <el-col :span="5">
          <div class="detail_l">项目现状：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r">{{detail.project_status_name}}&nbsp;</div>
        </el-col>
        <el-col :span="5">
          <div class="detail_l">行业分类：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r">{{detail.field_Name}}&nbsp;</div>
        </el-col>
        <el-col :span="5">
          <div class="detail_l">项目标签：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r">{{detail.project_lables}}&nbsp;</div>
        </el-col>
        <el-col :span="5">
          <div class="detail_l">项目计划书：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r">
            <a
              target="_blank"
              v-if="detail.proposalPath && detail.proposalPath.length"
              :href="detail.proposalPath"
              :download="detail.proposalPath"
            >查看附件</a>&nbsp;
          </div>
        </el-col>
        <el-col :span="5">
          <div class="detail_l">项目简介：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r">{{detail.synopsis}}&nbsp;</div>
        </el-col>
        <el-col :span="5">
          <div class="detail_l">其他证明：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r">
            <a
              target="_blank"
              v-if="detail.project_other_filePath && detail.project_other_filePath.length"
              :href="detail.project_other_filePath"
              :download="detail.project_other_filePath"
            >查看附件</a>&nbsp;
          </div>
        </el-col>
        <!-- <el-col :span="5">
          <div class="detail_l">承诺书：</div>
        </el-col> -->
        <!-- <el-col :span="19">
          <div class="detail_r">
            <a
              target="_blank"
              v-if="detail.promisePath && detail.promisePath.length"
              :href="detail.promisePath"
              download="承诺书"
            >查看附件</a>&nbsp;
          </div>
        </el-col> -->
      </el-row>
      <h2>团队信息</h2>
      <el-row>
        <el-col :span="5">
          <div class="detail_l">团队情况：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r">{{detail.is_team===true?"已有团队":"尚未组队"}}&nbsp;</div>
        </el-col>
        <el-col :span="5">
          <div class="detail_l">团队总人数：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r">{{detail.is_team===true?detail.personnel:''}}&nbsp;</div>
        </el-col>
        <el-col :span="5">
          <div class="detail_l">团队人员照片：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r">
            <template v-for="item in image_detailsPath">
              <img :src="item" style="width: 82px;height: 82px;"  />&nbsp;
            </template>
            
          </div>
        </el-col>
      </el-row>
      <h2 v-if="detail.is_team===true">核心人员情况</h2>
      <el-table
        :data="list"
        border
        style="width: 100%;margin-top:20px;"
        class="mt18"
        v-if="detail.is_team===true"
      >
        <el-table-column prop="team_member_name" label="姓名"></el-table-column>
        <el-table-column prop="team_member_major" label="专业"></el-table-column>
        <el-table-column prop="team_member_education_name" label="学历"></el-table-column>
        <el-table-column prop="team_member_post" label="职位"></el-table-column>
        <el-table-column prop="team_member_id_card" label="身份证号"></el-table-column>
        <el-table-column prop="team_member_phone" label="手机号"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      detail: {},
      list: [],
      image_detailsPath:[],//团队成员照片
    };
  },
  computed: {
    info() {
      return this.$store.state.info;
    }
  },
  created() {
    if (this.$store.state.info) {
      this.getEnterprises(); /** 查询认证 用于二次编辑*/
    } else {
      this.needInfo("getEnterprises");
    }
  },
  methods: {
    /* 监测Props */
    needInfo(name) {
      let watchAch = this.$watch("info", (val, oldVal) => {
        if (val) {
          this[name]();
          watchAch(); //取消监听
        }
      });
    },
    // 查询列表
    getExtends() {
      let params = Object.assign(
        {},
        {
          code: this.detail.code,
          type: "StarryExtendTypeTeamMember",
          pageSize: 10
        }
      );
      this.api.getExtends(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        this.list = res.obj.list;
      });
    },
    /** 查询认证*/
    getEnterprises() {
      let params = {
        id:
          this.$route.query.id ||
          sessionStorage.getItem("adminToParkCertificationTmpId")
      };
      this.api.getEnterprises(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        let obj = res.obj.list[0] || {};
        this.detail = obj;
        if(obj.image_detailsPath){
          this.image_detailsPath = obj.image_detailsPath.length?obj.image_detailsPath.split('|'):[];
        }
        
        if (this.detail.is_team) {
          this.getExtends();
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.certification_details {
  line-height: 41px;
  .tit {
    .back {
      display: inline-block;
      width: 38px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      border: 1px solid #dcdfe6;
      margin-right: 14px;
      cursor: pointer;
      vertical-align: middle;
    }
  }
  .detail_l {
    text-align: right;
  }
  .detail_r {
  }
  h2 {
    font-weight: 700;
    font-size: 20px;
    text-indent: 40px;
  }
}
</style>